import api from '@/services/api'

export async function selectTestTopics(topics: string[]) {
  const { data } = await api.patch('/fluency-test/topics', { topics })
  return data
}
